export default {
    methods:{
        buildCacheFilter(form){
            let params = {};
            for (let b=0;b<form.length;b++) {
                for (let e = 0; e < form[b].elements.length; e++) {
                    const key = form[b].elements[e].elementGetParamMap;
                    if (!this.$GVO.isEmpty(form[b].elements[e].element_model)) {
                        if (form[b].elements[e].elementType == 'select-tree'){
                            if (!this.$GVO.isEmpty(form[b].elements[e].element_model.selectedVal)) {
                                params[key] = form[b].elements[e].element_model.selectedVal;
                            }else{
                                delete params[key];
                            }
                        } else if(form[b].elements[e].elementType == 'input-date-range' || form[b].elements[e].elementType == 'input-time-range' || form[b].elements[e].elementType == 'input-range'){
                            const masDtKeys = key.split('|');
                            for (let index = 0; index < masDtKeys.length; index++) {
                                delete params[masDtKeys[index]];
                            }
                            if(form[b].elements[e].element_model.startDt != ''){
                                params[masDtKeys[0]] = form[b].elements[e].element_model.startDt;
                            }
                            if(form[b].elements[e].element_model.endDt != ''){
                                params[masDtKeys[1]] = form[b].elements[e].element_model.endDt;
                            }
                            
                            if(form[b].elements[e].element_model.min != ''){
                                params[masDtKeys[0]] = form[b].elements[e].element_model.min;
                            }
                            if(form[b].elements[e].element_model.max != ''){
                                params[masDtKeys[1]] = form[b].elements[e].element_model.max;
                            }
                        } else if(form[b].elements[e].elementType == 'checkbox-group' || form[b].elements[e].elementType == 'select-cascade-services' || form[b].elements[e].elementType == 'ajax-list-client'){
                            params = {...params, ...form[b].elements[e].element_model}
                        } else if(form[b].elements[e].elementType == 'ajax-list'){
                            params[key] = JSON.stringify(form[b].elements[e].element_model);
                        } else if(form[b].elements[e].elementType == 'select-objcat'){
                            params[key] = JSON.stringify(form[b].elements[e].element_model);
                        } else if(form[b].elements[e].elementType == 'date-range-strange'){
                            const masDtKeys = form[b].elements[e].elementGetParamMap.split('|');
                            //console.log(masDtKeys);
                            if(form[b].elements[e].element_model[masDtKeys[0]]=='-1' && form[b].elements[e].element_model[masDtKeys[1]].startDt != '' &&	form[b].elements[e].element_model[masDtKeys[1]].endDt != ''){
                                params[masDtKeys[1]] = form[b].elements[e].element_model[masDtKeys[1]].startDt+';'+form[b].elements[e].element_model[masDtKeys[1]].endDt;
                            }
                            params[masDtKeys[0]] = form[b].elements[e].element_model[masDtKeys[0]];
                        } else {
                            //console.log(key,form[b].elements[e].element_model);
                            params[key] = form[b].elements[e].element_model;
                        }
                    }else{
                        delete params[key];
                        if( form[b].elements[e].elementType == 'input-date-range' || 
                            form[b].elements[e].elementType == 'input-time-range' ||
                            form[b].elements[e].elementType == 'checkbox-group'   || 
                            form[b].elements[e].elementType == 'input-range'
                        ){
                            const masDtKeys = key.split('|');
                            for (let index = 0; index < masDtKeys.length; index++) {
                                delete params[masDtKeys[index]];
                            }
                        }
                    }
                }
            }
            return params;
        },// TODO
        SetFilterParams(form, params){
            this.objPassthroughOpts = [];
            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    let element = this.GetConfElement(key, form);
                    if(element === false){
                        this.objPassthroughOpts.push(key);
                    }else{
                        if(element.elementType == 'select-tree'){
                            let masRetTree = [];
                            this.$GVO.SeachTreeReq(this.$GVO.masTreeOrgStruct,'id',params[key],masRetTree);
                            element.element_model = {inputText: masRetTree[0].name, selectedVal:params[key]};
                        } else if(element.elementType == 'input-date-range' || element.elementType == 'input-time-range'){
                            if(element.elementGetParamMap.indexOf(key+'|') != -1){
                                element.element_model.startDt = params[key];
                            }
                            if(element.elementGetParamMap.indexOf('|'+key) != -1){
                                element.element_model.endDt = params[key];
                            }
                        } else if(element.elementType == 'input-range'){
                            if(element.elementGetParamMap.indexOf(key+'|') != -1){
                                element.element_model.min = params[key];
                            }
                            if(element.elementGetParamMap.indexOf('|'+key) != -1){
                                element.element_model.max = params[key];
                            }
                        } else if(element.elementType == 'checkbox-group'){
                            const masDtKeys = element.elementGetParamMap.split('|');
                            for (let i = 0; i < masDtKeys.length; i++) {
                                if(masDtKeys[i] == key){
                                    //console.log(key,typeof params[key]);
                                    if(typeof params[key] === 'string')
                                        element.element_model[key] = params[key]=='true'?true:false;
                                    if(typeof params[key] === 'boolean')
                                        element.element_model[key] = params[key];
                                }
                            }
                        } else if(element.elementType == 'checkbox'){
                            element.element_model = params[key]=='true'?true:false;
                        } else if(element.elementType == 'switcher'){
                            element.element_model = params[key]=='true'?true:false;
                        } else if(element.elementType == 'select'){
                            if(element.multiple){
                                if(typeof params[key] === 'string'){
                                    element.element_model = params[key].split(',');
                                }else{
                                    element.element_model = params[key];
                                }
                            }else{
                                element.element_model = params[key];
                            }
                        } else if(element.elementType == 'select-cascade-services'){
                            //console.log(key,params[key]);
                            element.element_model[key]=params[key];
                        } else if(element.elementType == 'ajax-list-client'){
                            //console.log(key,params[key]);
                            element.element_model[key]=params[key];
                        } else if(element.elementType == 'ajax-list'){
                            //console.log(key,params[key]);
                            element.element_model=JSON.parse(params[key]);
                        } else if(element.elementType == 'select-objcat'){
                            //console.log(key,params[key]);
                            element.element_model=JSON.parse(params[key]);
                        } else if(element.elementType == 'date-range-strange'){ 
                            const masDtKeys = element.elementGetParamMap.split('|');
                            //console.log(masDtKeys[0],params[masDtKeys[0]]);
                            element.element_model[masDtKeys[0]]=params[masDtKeys[0]];
                            if(typeof params[masDtKeys[1]] !='undefined'){
                                const dates = params[masDtKeys[1]].split(';');
                                element.element_model[masDtKeys[1]].startDt=dates[0];
                                element.element_model[masDtKeys[1]].endDt=dates[1];
                            }
                        }else {
                            element.element_model = params[key];
                        }
                    }
                }
            }
        },                
        GetConfElement(elementGetParamMap, form){
            for (let i = 0; i < form.length; i++) {
                for (let iEl = 0; iEl < form[i].elements.length; iEl++) {
                    if(form[i].elements[iEl].elementGetParamMap == elementGetParamMap){
                        return form[i].elements[iEl];
                    }
                    if(form[i].elements[iEl].elementGetParamMap.indexOf('|'+elementGetParamMap+'|') != -1){
                        return form[i].elements[iEl];
                    }
                    if(form[i].elements[iEl].elementGetParamMap.indexOf(elementGetParamMap+'|') != -1){
                        return form[i].elements[iEl];
                    }
                    if(form[i].elements[iEl].elementGetParamMap.indexOf('|'+elementGetParamMap) != -1){
                        return form[i].elements[iEl];
                    }
                }
            }
            return false;
        },        
    }
}